import { ActionType, ProColumns } from '@ant-design/pro-components';
import { DatePicker, Form, message } from 'antd';
import BoxContainer from 'base/ui/components/BoxContainer';
import CustomButton from 'base/ui/components/Button';
import { cloneDeep } from 'lodash';
import { observer } from 'mobx-react';
import { useEffect, useRef, useState } from 'react';
// icons
import CustomSelect from 'base/ui/components/CustomSelect';
import CustomProTable from 'base/ui/components/CustomTable';
import * as Icon from 'base/ui/components/Icons';
import PageWrapper from 'pages/Components/PageWrapper';
import { SearchBox, SearchForm, SearchItem } from 'pages/Components/SearchBox';
import { useTranslation } from 'react-i18next';
import { PAGE_SIZE_DEFAULT, SYSTEM_TITLE } from 'utils/constants';
import { SSXLKN3MModel } from 'services/Main/reportWAndC_service';
import { commonPresenter, commonStore, reportWCPresenter, reportWCStore, uiStore } from 'stores/root_store';
import { PagingModel, SearchModel } from 'pages/model';
import { formatNumber } from 'utils/formatHelper';
import { CommonModel } from 'services/Main/common_services';
import { AiOutlineDownload } from 'react-icons/ai';
import SaveReportForm from 'pages/Components/reportForm';
import { useResizableColumns } from 'utils/reportHelper';
import dayjs from 'dayjs';
import { checkPermission, useCheckPermission } from 'utils/permissionHelper';

const { RangePicker } = DatePicker;

export type TableListItem = {
  stt: number;
  region: string;
  soTHKT: number;
  gtSPKT: number;
  gtBHKT: number;
  gtGGKT: number;
  tyLeKT: number;
  soTHKBC: number;
  gtSPKBC: number;
  gtBHKBC: number;
  gtGGKBC: number;
  tyLeKBC: number;
  tyLeTong: number;
};


// SO SÁNH XLKN 3 MIỀN ==============================================================================================
// const tableListDataSource: TableListItem[] = [];
const createBCSoSanh3Mien = () => {
  return observer(() => {
    useCheckPermission('INDEX');
    //=====================================CHUYỂN NGÔN NGỮ=====================================//
    const { t } = useTranslation();
    document.title = t('page-title.ss-xlkn-3mien') + ' - ' + SYSTEM_TITLE;
    const [form] = Form.useForm();

    const [open, setOpen] = useState({
      openDrawer: false,
      openModal: false,
      openConfirm: false,
    });

    // Phân trang và sort
    const [dataPaging, setDataPaging] = useState<SearchModel>({
      fromTime: undefined,
      toTime: undefined,
      reportFromTime: undefined,
      reportToTime: undefined,
      listUsualErrorCode: undefined,
      productLevelCode: undefined,
      productCategoryCode: undefined,
      productColorCode: undefined,
    });
    // Dữ liệu table
    const [dataTable, setDataTable] = useState<SSXLKN3MModel[]>([]);
    // data common date
    const [listCommonDate, setListCommonDate] = useState<CommonModel[]>([]);
    //Dropdown các lỗi bảo hành thường gặp: UsualError
    const [listUsualError, setListUsualError] = useState<CommonModel[]>([]);
    // Dropdown phân cấp sản phẩm: ProductLevel
    const [listProductLevel, setListProductLevel] = useState<CommonModel[]>([]);
    // Dropdown nhóm vật tư: ProductCategory
    const [listProductCategory, setListProductCategory] = useState<CommonModel[]>([]);
    // Dropdown mã màu sản phẩm: ProductColor
    const [listProductColor, setListProductColor] = useState<CommonModel[]>([]);

    const [isSearch, setIsSearch] = useState(false);
    const [exportLoading, setExportLoading] = useState(false);
    const [disabledKyTruoc, setDisabledKyTruoc] = useState(false);
    const [disabledKyBC, setDisabledKyBC] = useState(false);

    const defaultColumn: ProColumns<SSXLKN3MModel>[] = [
      {
        title: t('zalo-notification.stt'),
        dataIndex: 'stt',
        key: 'stt',
        fixed: 'left',
        width: 50,
        align: 'center',
      },
      {
        title: t('search-form.area'),
        dataIndex: 'khuVuc',
        key: 'khuVuc',
        fixed: 'left',
        width: 200,
      },
      // Kỳ trước
      {
        title: t('complaint.ky-truoc'),
        key: 'kyTruoc',
        children: [
          // Số trường hợp xlkn
          {
            title: t('complaint.so-th-xlkn'),
            dataIndex: 'soTHXLKNKyTruoc',
            key: 'soTHXLKNKyTruoc',
            width: 150,
            onCell: (_, index) => ({
              className: 'text-right',
            }),
            render: (text, record) => (text !== '-' ? formatNumber(Number(text), 0) : text),
          },
          // giá trị sản phẩm
          {
            title: t('complaint.gia-tri-sp'),
            dataIndex: 'gtspKyTruoc',
            key: 'gtspKyTruoc',
            width: 150,
            onCell: (_, index) => ({
              className: 'text-right',
            }),
            render: (text, record) => (text !== '-' ? formatNumber(Number(text), 0) : text),
          },
          // Giá trị bảo hành
          {
            title: t('complaint.gia-tri-bh'),
            dataIndex: 'gtbhKyTruoc',
            key: 'gtbhKyTruoc',
            width: 150,
            onCell: (_, index) => ({
              className: 'text-right',
            }),
            render: (text, record) => (text !== '-' ? formatNumber(Number(text), 0) : text),
          },
          // Giá trị giảm giá
          {
            title: t('complaint.gia-tri-gg'),
            dataIndex: 'gtggKyTruoc',
            key: 'gtggKyTruoc',
            width: 150,
            onCell: (_, index) => ({
              className: 'text-right',
            }),
            render: (text, record) => (text !== '-' ? formatNumber(Number(text), 0) : text),
          },
          // tỷ lệ
          {
            title: t('complaint.ty-le-gia-tri'),
            className: 'whitespace-pre-line',
            dataIndex: 'tyLeKyTruoc',
            key: 'tyLeKyTruoc',
            width: 150,
            onCell: (_, index) => ({
              className: 'text-right',
            }),
            render: (text, record) => (text !== '-' ? formatNumber(Number(text), 0) + '%' : text),
          },
        ],
      },
      // kỳ báo cáo
      {
        title: t('complaint.ky-bc'),
        key: 'kyBaoCao',
        children: [
          {
            title: t('complaint.so-th-xlkn'),
            dataIndex: 'soTHXLKNKyBC',
            key: 'soTHXLKNKyBC',
            width: 150,
            onCell: (_, index) => ({
              className: 'text-right',
            }),
            render: (text, record) => (text !== '-' ? formatNumber(Number(text), 0) : text),
          },
          {
            title: t('complaint.gia-tri-sp'),
            dataIndex: 'gtspKyBC',
            key: 'gtspKyBC',
            width: 150,
            onCell: (_, index) => ({
              className: 'text-right',
            }),
            render: (text, record) => (text !== '-' ? formatNumber(Number(text), 0) : text),
          },
          {
            title: t('complaint.gia-tri-bh'),
            dataIndex: 'gtbhKyBC',
            key: 'gtbhKyBC',
            width: 150,
            onCell: (_, index) => ({
              className: 'text-right',
            }),
            render: (text, record) => (text !== '-' ? formatNumber(Number(text), 0) : text),
          },
          {
            title: t('complaint.gia-tri-gg'),
            dataIndex: 'gtggKyBC',
            key: 'gtggKyBC',
            width: 150,
            onCell: (_, index) => ({
              className: 'text-right',
            }),
            render: (text, record) => (text !== '-' ? formatNumber(Number(text), 0) : text),
          },
          {
            title: t('complaint.ty-le-gia-tri'),
            className: 'whitespace-pre-line',
            dataIndex: 'tyLeKyBC',
            key: 'tyLeKyBC',
            width: 150,
            onCell: (_, index) => ({
              className: 'text-right',
            }),
            render: (text, record) => (text !== '-' ? formatNumber(Number(text), 0) + '%' : text),
          },
        ],
      },
      {
        title: t('complaint.ty-le-th'),
        className: 'whitespace-pre-line',
        dataIndex: 'tyLeGiua2Ky',
        key: 'tyLeGiua2Ky',
        width: 150,
        onCell: (_, index) => ({
          className: 'text-right',
        }),
        render: (text, record) => (text !== '-' ? formatNumber(Number(text), 0) + '%' : text),
      },
    ];
    const [columns, setColumns] = useState<ProColumns<SSXLKN3MModel>[]>(defaultColumn);

    // ======================================================== function =================================================================
    // get data table
    const getDataTable = async (data: any) => {
      // const tempt = { ...data }
      // Object.fromEntries(Object.entries(tempt).filter(([_, value]) => !!value))

      await reportWCPresenter.getDataSSXLKN3M(reportWCStore, { ...data, lang: uiStore.language });
      if (reportWCStore.reportSSXLKN3M.isSuccess) {
        const data = cloneDeep(reportWCStore.reportSSXLKN3M.data);
        setDataTable(data);
        return data;
      } else {
        message.error(reportWCStore.reportSSXLKN3M.message);
        return [];
      }
    };
    // Lấy danh sách common date
    const getListCommonDate = async () => {
      await commonPresenter.getListSelectCommonDate(commonStore);
      if (commonStore.commonRespone.isSuccess) {
        setListCommonDate(commonStore.commonRespone.data);
      }
    };

    // Lấy ngày bằng common data
    const getDateByKey = async (key: string, type: 'kyTruoc' | 'kyBC') => {
      await commonPresenter.getDateByCommonDate(commonStore, key);
      if (commonStore.commonDate.fromDate) {
        switch (type) {
          case 'kyBC':
            form.setFieldValue('kyBaoCao', [
              dayjs(commonStore.commonDate.fromDate),
              dayjs(commonStore.commonDate.toDate),
            ]);
            break;
          case 'kyTruoc':
            form.setFieldValue('kyTruoc', [
              dayjs(commonStore.commonDate.fromDate),
              dayjs(commonStore.commonDate.toDate),
            ]);
            break;
        }
      } else {
        switch (type) {
          case 'kyBC':
            form.setFieldValue('kyBaoCao', undefined);
            break;
          case 'kyTruoc':
            form.setFieldValue('kyTruoc', undefined);
            break;
        }
      }
    };

    // Lấy danh sách Loại  (các lỗi bảo hành thường gặp)
    const getListUsualError = async () => {
      await commonPresenter.getCommonDataByKey(commonStore, 'UsualError');
      if (commonStore.commonRespone.isSuccess) {
        setListUsualError(commonStore.commonRespone.data);
      }
    };
    // Lấy Dropdown phân cấp sản phẩm:
    const getListProductLevel = async () => {
      await commonPresenter.getCommonDataByKey(commonStore, 'ProductLevel');
      if (commonStore.commonRespone.isSuccess) {
        setListProductLevel(commonStore.commonRespone.data);
      }
    };
    // Lấy Dropdown nhóm vật tư: ProductCategory
    const getListProductCategory = async () => {
      await commonPresenter.getCommonDataByKey(commonStore, 'ProductCategory');
      if (commonStore.commonRespone.isSuccess) {
        setListProductCategory(commonStore.commonRespone.data);
      }
    };
    // Lấy Dropdown mã màu sản phẩm: ProductColor
    const getListProductColor = async () => {
      await commonPresenter.getCommonDataByKey(commonStore, 'ProductColor');
      if (commonStore.commonRespone.isSuccess) {
        setListProductColor(commonStore.commonRespone.data);
      }
    };

    useEffect(() => {
      getListCommonDate();
      getListUsualError();
      getListProductLevel();
      getListProductCategory();
      getListProductColor();
    }, []);

    // show filter form
    const showDrawer = () => {
      setOpen({ ...open, openDrawer: true });
    };
    // close filter form
    const onClose = () => {
      setOpen({ ...open, openDrawer: false });
    };
    // hidden modal (Add)

    // ============================================LƯU MẪU BÁO CÁO =========================================

    const tableRef = useRef<ActionType>();
    const constDataName = 'BCSSXLKN3Mien';
    const {
      isResizablePresent,
      setIsResizablePresent,
      resizableColumnSelect,
      columnsState,
      handleColumnsStateChange,
      templateReportModalRef,
      userReports,
      selectedReportId,
      templateReportModalProps,
      handleResize,
    } = useResizableColumns<SSXLKN3MModel>(columns, setColumns, constDataName);

    return (
      <PageWrapper
        breadcrumb={[
          {
            text: t('page-title.ss-xlkn-3mien'),
          },
        ]}
        extras={
          <>
            <CustomButton onClick={showDrawer} type="primary" color="#EFF4F9" className="!px-0 w-8">
              <Icon.Filter className="!fill-primary" />
            </CustomButton>
          </>
        }
      >
        {/* Table */}
        <BoxContainer fullHeight>
          <CustomProTable<SSXLKN3MModel>
            className="[&_.ant-table-thead_th]:!text-center"
            columns={columns}
            handleResize={handleResize}
            isResizablePresent={isResizablePresent}
            resizableColumnSelect={resizableColumnSelect}
            dataSource={dataTable}
            request={async (params = {}, sort, filter) => {
              if (isSearch) {
                const data = await getDataTable(dataPaging);
                return {
                  data: data,
                  success: reportWCStore.reportSSXLKN3M.isSuccess,
                };
              }
              return [];
            }}
            actionRef={tableRef}
            pagination={false}
            bordered
            columnsState={{
              value: Object.keys(columnsState).length > 0 ? columnsState : undefined,
              onChange: (newColumnsState) => {
                handleColumnsStateChange(newColumnsState);
              },
            }}
            toolBarRender={() => [
              <>
                {checkPermission('EXPORT') ? (
                  <CustomButton
                    size="middle"
                    loading={exportLoading}
                    onClick={async () => {
                      setExportLoading(true);
                      await reportWCPresenter.exportExportReportSSXLKN3M({ ...dataPaging, lang: uiStore.language });
                      setExportLoading(false);
                    }}
                    className="bg-primary !flex justify-between items-center gap-2 !px-3 !rounded-sm !py-1"
                    type="primary"
                  >
                    <AiOutlineDownload className="block text-base" />
                    <span className="block">{t('btn.export')}</span>
                  </CustomButton>
                ) : (
                  ''
                )}
              </>,
              <SaveReportForm
                setIsResizablePresent={setIsResizablePresent}
                templateReportModalRef={templateReportModalRef}
                userReports={userReports}
                selectedReportId={selectedReportId}
                templateReportModalProps={templateReportModalProps}
              />,
            ]}
          />
        </BoxContainer>

        {/* Form search */}
        <SearchBox
          onClose={onClose}
          open={open.openDrawer}
          className="lg:!w-[50%]"
          footer={
            <CustomButton
              htmlType="submit"
              onClick={() => {
                setIsSearch(true);

                const kyTruoc = form.getFieldValue('kyTruoc');
                const kyBaoCao = form.getFieldValue('kyBaoCao');
                let errorBH = form.getFieldValue('listUsualErrorCode');
                let phanCapSP = form.getFieldValue('productLevelCode');
                let maMau = form.getFieldValue('productColorCode');
                let nhomVatTu = form.getFieldValue('productCategoryCode');

                let reportFromTime = undefined;
                let reportToTime = undefined;
                let fromTime = undefined;
                let toTime = undefined;
                if (kyBaoCao) {
                  reportFromTime = form.getFieldValue('kyBaoCao')[0].format('YYYY-MM-DD') || undefined;
                  reportToTime = form.getFieldValue('kyBaoCao')[1].format('YYYY-MM-DD') || undefined;
                }
                if (kyTruoc) {
                  fromTime = form.getFieldValue('kyTruoc')[0].format('YYYY-MM-DD') || undefined;
                  toTime = form.getFieldValue('kyTruoc')[1].format('YYYY-MM-DD') || undefined;
                }

                setDataPaging({
                  ...form.getFieldsValue(),
                  listUsualErrorCode: errorBH && errorBH?.length !== 0 ? errorBH : undefined,
                  productLevelCode: phanCapSP && phanCapSP?.length !== 0 ? phanCapSP : undefined,
                  productColorCode: maMau && maMau?.length !== 0 ? maMau : undefined,
                  productCategoryCode: nhomVatTu && nhomVatTu?.length !== 0 ? nhomVatTu : undefined,
                  fromTime: fromTime,
                  toTime: toTime,
                  reportFromTime: reportFromTime,
                  reportToTime: reportToTime,
                });
                form.submit();
              }}
              className="my-auto ml-auto"
              type="primary"
            >
              {t('btn.search')}
            </CustomButton>
          }
        >
          <SearchForm
            form={form}
            onFinish={() => {
              tableRef.current?.reload();
            }}
          >
            {/* kỳ báo cáo (common)*/}
            <SearchItem name={'commonKyBC'} label={t('search-form.report-time')}>
              <CustomSelect
                options={listCommonDate}
                fieldNames={{ label: 'value', value: 'key' }}
                onChange={async (value, option) => {
                  if (option) {
                    setDisabledKyBC(option.key === 'Custom' ? false : true);
                    await getDateByKey(option.key, 'kyBC');
                  } else {
                    setDisabledKyBC(false);
                    form.setFieldValue('kyBaoCao', undefined);
                  }
                }}
                allowClear
              />
            </SearchItem>

            {/* chọn ngày*/}
            <SearchItem rules={[{ required: true, message: t('message.required-report-time') }]} name={'kyBaoCao'} col2>
              <RangePicker disabled={disabledKyBC} format="DD/MM/YYYY" className="w-full" />
            </SearchItem>
            {/* kỳ trước (common) */}
            <SearchItem name={'commonKyTruoc'} label={t('search-form.ky-truoc')}>
              <CustomSelect
                options={listCommonDate}
                fieldNames={{ label: 'value', value: 'key' }}
                onChange={async (value, option) => {
                  if (option) {
                    setDisabledKyTruoc(option.key === 'Custom' ? false : true);
                    await getDateByKey(option.key, 'kyTruoc');
                  } else {
                    setDisabledKyTruoc(false);
                    form.setFieldValue('kyTruoc', undefined);
                  }
                }}
                allowClear
              />
            </SearchItem>

            {/* chọn ngày*/}
            <SearchItem
              name={'kyTruoc'}
              rules={[{ required: true, message: t('message.required-report-last-time') }]}
              col2
            >
              <RangePicker disabled={disabledKyTruoc} format="DD/MM/YYYY" className="w-full" />
            </SearchItem>
            {/* Loại (Các lỗi bh thường gặp) */}
            <SearchItem name={'listUsualErrorCode'} label={t('search-form.errors')}>
              <CustomSelect
                mode="multiple"
                options={listUsualError}
                fieldNames={{ label: 'value', value: 'key' }}
                filterOption={(input, option) => (option?.value ?? '').toLowerCase().includes(input.toLowerCase())}
                allowClear
                showSearch
              />
            </SearchItem>
            {/* Phân cấp sản phẩm */}
            <SearchItem name={'productLevelCode'} label={t('search-form.phan-cap-sp')}>
              <CustomSelect
                mode="multiple"
                options={listProductLevel}
                fieldNames={{ label: 'value', value: 'key' }}
                showSearch
                allowClear
                filterOption={(input, option) => (option?.value ?? '').toLowerCase().includes(input.toLowerCase())}
              />
            </SearchItem>
            {/* Nhóm vật tư */}
            <SearchItem name={'productCategoryCode'} label={t('search-form.nhom-vat-tu')}>
              <CustomSelect
                mode="multiple"
                options={listProductCategory}
                fieldNames={{ label: 'value', value: 'key' }}
                showSearch
                allowClear
                filterOption={(input, option) => (option?.value ?? '').toLowerCase().includes(input.toLowerCase())}
              />
            </SearchItem>
            {/* Mã màu */}
            <SearchItem name={'productColorCode'} label={t('search-form.color-code')}>
              <CustomSelect
                mode="multiple"
                options={listProductColor}
                fieldNames={{ label: 'value', value: 'key' }}
                showSearch
                allowClear
                filterOption={(input, option) => (option?.value ?? '').toLowerCase().includes(input.toLowerCase())}
              />
            </SearchItem>
          </SearchForm>
        </SearchBox>
      </PageWrapper>
    );
  });
};

export default createBCSoSanh3Mien;
